// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 7: BRIEFE UND OFFENBARUNG
// ============================================================================
// Level 79-91 (13 Level, 39 Fragen)

export const chapter7Translations = {
  name: "Briefe und Offenbarung",
  description: "Wer überwindet, wird dies alles erben... Weisheit von oben heiligt den Verstand",
  
  spiritualWisdom: {
    principle: "Die Weisheit von oben heiligt den Verstand und belebt den Geist",
    scripture: "Wenn aber jemandem unter euch Weisheit mangelt, so bitte er Gott (Jakobus 1,5)",
    application: "Jeder apostolische Brief und jede Vision der Offenbarung bereichert unser Verständnis und stärkt unsere Hoffnung"
  },
  
  levels: {
    79: {
      name: "Verhaftung in Jerusalem",
      challenge: "Ich bin bereit, nicht nur gebunden zu werden, sondern auch in Jerusalem zu sterben...",
      easy: {
        question: "Wo wurde Paulus bei seinem letzten Besuch verhaftet?",
        options: ["Antiochia", "Ephesus", "Jerusalem", "Korinth"],
        correctAnswer: 2,
        hint: "Die heilige Stadt, die oft Propheten verfolgte",
        funFact: "🏛️ Jerusalem: Ort der Herrlichkeit und des Leidens für alle Diener Gottes!"
      },
      medium: {
        question: "Was warfen die Juden Paulus vor?",
        options: [
          "Diebstahl aus dem Tempel",
          "Entweihung des Tempels durch Einführung von Heiden",
          "Lästerung gegen Mose",
          "Rebellion gegen Rom"
        ],
        correctAnswer: 1,
        hint: "Anklage bezüglich der Universalität des Evangeliums",
        funFact: "⛪ Ironie: Paulus beschuldigt, den Tempel zu entweihen, den er zutiefst ehrte!"
      },
      hard: {
        question: "Wie verwandelte Paulus seine Gefangenschaft in eine Gelegenheit?",
        options: [
          "Er floh",
          "Er zeugte vor Autoritäten und schrieb seine Briefe",
          "Er schwieg",
          "Er verhandelte seine Freilassung"
        ],
        correctAnswer: 1,
        hint: "Es geht um die Verwandlung der Prüfung in Zeugnis",
        funFact: "⛓️ Physische Ketten, geistliche Freiheit - kraftvolles Zeugnis des Glaubens!"
      }
    },
    
    80: {
      name: "Vor Statthalter Felix",
      challenge: "Als er aber redete von Gerechtigkeit und Enthaltsamkeit und dem zukünftigen Gericht...",
      easy: {
        question: "Vor welchem Statthalter bezeugte Paulus seinen Glauben?",
        options: ["Pilatus", "Felix", "Festus", "Gallio"],
        correctAnswer: 1,
        hint: "Statthalter bekannt für seine Habgier",
        funFact: "⚖️ Felix hoffte auf Bestechung - Korruption trifft auf Integrität!"
      },
      medium: {
        question: "Was war Felix' Reaktion auf Paulus' Botschaft?",
        options: [
          "Er bekehrte sich",
          "Er erschrak vor Furcht",
          "Er spottete",
          "Er blieb gleichgültig"
        ],
        correctAnswer: 1,
        hint: "Das von der Wahrheit beunruhigte Gewissen",
        funFact: "😰 Selbst die Korrupten erschrecken vor der göttlichen Wahrheit - universelles Gewissen!"
      },
      hard: {
        question: "Warum hielt Felix Paulus zwei Jahre lang gefangen?",
        options: [
          "Um ihn zu schützen",
          "Aus politischem Interesse und Hoffnung auf Korruption",
          "Aus Vergesslichkeit",
          "Aus Überzeugung"
        ],
        correctAnswer: 1,
        hint: "Es geht um politische und persönliche Berechnungen",
        funFact: "🏛️ Korrupte menschliche Gerechtigkeit vs. vollkommene göttliche Gerechtigkeit - deutlicher Kontrast!"
      }
    },

    81: {
      name: "Berufung an den Kaiser",
      challenge: "Auf den Kaiser berufe ich mich!",
      easy: {
        question: "Welches Recht berief Paulus an, um einen Prozess in Jerusalem zu vermeiden?",
        options: [
          "Asylrecht",
          "Berufung an den Kaiser (römischer Bürger)",
          "Fluchtrecht",
          "Diplomatischer Schutz"
        ],
        correctAnswer: 1,
        hint: "Privileg seiner römischen Staatsbürgerschaft",
        funFact: "🏛️ Römische Staatsbürgerschaft: göttlicher Pass, um das Evangelium nach Rom zu bringen!"
      },
      medium: {
        question: "Vor wem zeugte Paulus vor seiner Abreise?",
        options: [
          "Dem Sanhedrin",
          "König Agrippa und Berenike",
          "Römischen Soldaten",
          "Der jüdischen Menge"
        ],
        correctAnswer: 1,
        hint: "Judaisierte herodianische Königswürde",
        funFact: "👑 Vom Schafhirten zum Königspalast - göttliche Erhebung des Paulus!"
      },
      hard: {
        question: "Wie nutzt Gott menschliche Systeme für seine Pläne?",
        options: [
          "Er ignoriert sie",
          "Er nutzt sie providenziell, um seine Absichten zu erfüllen",
          "Er zerstört sie",
          "Er widersetzt sich ihnen immer"
        ],
        correctAnswer: 1,
        hint: "Es geht um göttliche Souveränität über die Geschichte",
        funFact: "🌐 Römische Gerechtigkeit wird zum Vehikel des Evangeliums - bemerkenswerte Vorsehung!"
      }
    },

    82: {
      name: "Schiffbruch auf Malta",
      challenge: "Fürchte dich nicht, Paulus; du musst vor den Kaiser treten...",
      easy: {
        question: "Auf welcher Insel erlitt Paulus Schiffbruch?",
        options: ["Kreta", "Zypern", "Malta", "Sizilien"],
        correctAnswer: 2,
        hint: "Kleine Insel südlich von Sizilien",
        funFact: "🏝️ Malta: Zwangsstopp wird zu fruchtbarer Mission - göttliche Umwege!"
      },
      medium: {
        question: "Welches Wunder vollbrachte Paulus auf Malta?",
        options: [
          "Er beruhigte den Sturm",
          "Er heilte den Vater des Publius und andere Kranke",
          "Er vermehrte Nahrung",
          "Er erweckte einen Toten"
        ],
        correctAnswer: 1,
        hint: "Mehrfache Heilungen auf der Insel",
        funFact: "🏥 Paulus: Vom Schiffbrüchigen zum Wunderarzt - göttlicher Ruf!"
      },
      hard: {
        question: "Wie veranschaulicht dieser Schiffbruch Gottes Treue?",
        options: [
          "Unfälle passieren",
          "Gott schützt und erfüllt seine Verheißungen trotz Hindernissen",
          "Paulus hatte Glück",
          "Es war vermeidbar"
        ],
        correctAnswer: 1,
        hint: "Es geht um göttliche Treue zu Verheißungen",
        funFact: "⛈️ Sturm, Schiffbruch, Schlange: Nichts stoppt Gottes Plan für Paulus!"
      }
    },

    83: {
      name: "Paulus in Rom",
      challenge: "Er blieb zwei volle Jahre in einer eigenen Mietwohnung...",
      easy: {
        question: "Unter welchen Bedingungen lebte Paulus in Rom?",
        options: [
          "In geschlossenem Gefängnis",
          "Unter Hausarrest",
          "In völliger Freiheit",
          "Im Exil"
        ],
        correctAnswer: 1,
        hint: "Relative Freiheit unter Überwachung",
        funFact: "🏠 Haus-Gefängnis wird zum Missionszentrum - Freiheit in Ketten!"
      },
      medium: {
        question: "Was tat Paulus während seiner zwei Jahre in Rom?",
        options: [
          "Er ruhte sich aus",
          "Er lehrte und schrieb seine Briefe",
          "Er bereitete seine Verteidigung vor",
          "Er machte Sightseeing"
        ],
        correctAnswer: 1,
        hint: "Intensiver Dienst trotz Ketten",
        funFact: "✍️ Gefangenschaftsbriefe: Epheser, Philipper, Kolosser, Philemon!"
      },
      hard: {
        question: "Wie beendete Paulus seinen Dienst laut Tradition?",
        options: [
          "Er starb an Krankheit",
          "Er wurde unter Nero um 67 n.Chr. enthauptet",
          "Er starb an Altersschwäche",
          "Er verschwand mysteriös"
        ],
        correctAnswer: 1,
        hint: "Martyrium unter dem verrückten Kaiser",
        funFact: "⚔️ 'Ich habe den guten Kampf gekämpft, ich habe den Lauf vollendet' - endgültiger Sieg!"
      }
    },

    84: {
      name: "Der Römerbrief",
      challenge: "Ich schäme mich des Evangeliums nicht; es ist Gottes Kraft zum Heil...",
      easy: {
        question: "Welcher Brief entwickelt am meisten die Lehre vom Heil durch Glauben?",
        options: ["1. Korinther", "Galater", "Römer", "Epheser"],
        correctAnswer: 2,
        hint: "Die theologische 'Kathedrale' des Paulus",
        funFact: "🏛️ Römer: Theologisches Meisterwerk, das Augustinus und Luther bekehrte!"
      },
      medium: {
        question: "Wie wird der Mensch laut Römer vor Gott gerechtfertigt?",
        options: [
          "Durch seine guten Werke",
          "Durch Glauben allein, ohne Werke",
          "Durch Opfer",
          "Durch Tradition"
        ],
        correctAnswer: 1,
        hint: "Grundprinzip der Reformation",
        funFact: "⚖️ 'Der Gerechte wird aus Glauben leben' - geistliche Revolution des Paulus!"
      },
      hard: {
        question: "Was ist die universelle Reichweite dieses Briefes?",
        options: [
          "Er betrifft nur die Römer",
          "Er legt den Heilsplan für die gesamte Menschheit dar",
          "Er kritisiert nur Rom",
          "Er ist veraltet"
        ],
        correctAnswer: 1,
        hint: "Es geht um den universellen Heilsplan",
        funFact: "🌍 Evangelium = Gottes Kraft für alle: Juden und Griechen - totale Universalität!"
      }
    },

    85: {
      name: "Das Hohelied der Liebe - 1. Korinther 13",
      challenge: "Wenn ich in den Sprachen der Menschen und der Engel redete, aber keine Liebe hätte...",
      easy: {
        question: "Welches Kapitel der Bibel wird 'Hohelied der Liebe' genannt?",
        options: [
          "1. Korinther 12",
          "1. Korinther 13",
          "1. Johannes 4",
          "Römer 8"
        ],
        correctAnswer: 1,
        hint: "Das zentrale Kapitel in 1. Korinther",
        funFact: "💝 Das meistgelesene Kapitel bei Hochzeiten - perfekte Definition der Liebe!"
      },
      medium: {
        question: "Was sagt Paulus über die Dauer der Liebe?",
        options: [
          "Liebe vergeht mit der Zeit",
          "Die Liebe hört niemals auf",
          "Liebe hängt von Umständen ab",
          "Liebe ist zeitlich begrenzt"
        ],
        correctAnswer: 1,
        hint: "Ewigkeit der göttlichen Liebe",
        funFact: "♾️ Nur die Liebe überwindet Tod und Ewigkeit - höchster Wert!"
      },
      hard: {
        question: "Warum stellt Paulus die Liebe über die geistlichen Gaben?",
        options: [
          "Gaben sind schlecht",
          "Liebe gibt allem anderen Sinn und Wert",
          "Liebe ist einfacher",
          "Gaben spalten"
        ],
        correctAnswer: 1,
        hint: "Es geht um den Motor und Sinn allen Dienstes",
        funFact: "🎯 Ohne Liebe werden selbst die größten Gaben zu Lärm und Stolz!"
      }
    },

    86: {
      name: "Epheser: Die Gemeinde als Leib Christi",
      challenge: "Alles hat er unter seine Füße getan und ihn als Haupt über alles der Gemeinde gegeben...",
      easy: {
        question: "Was ist laut Epheser die Gemeinde in ihrer Beziehung zu Christus?",
        options: [
          "Sein Tempel",
          "Sein Leib",
          "Seine Familie",
          "Seine Armee"
        ],
        correctAnswer: 1,
        hint: "Organische Metapher der Einheit",
        funFact: "👤 Leib Christi: Jeder Christ ist ein lebenswichtiges Glied - gegenseitige Abhängigkeit!"
      },
      medium: {
        question: "Welche Rüstung beschreibt Paulus für den geistlichen Kampf?",
        options: [
          "Physische Rüstung",
          "Waffenrüstung Gottes: Wahrheit, Gerechtigkeit, Friede, Glaube, Heil, Wort",
          "Römische Rüstung",
          "Magischer Schutz"
        ],
        correctAnswer: 1,
        hint: "Sechs Teile geistlicher Rüstung",
        funFact: "⚔️ Geistlicher Kampf mit geistlichen Waffen - göttliche Siegesstrategie!"
      },
      hard: {
        question: "Gegen wen ist unser wahrer Kampf laut Paulus?",
        options: [
          "Gegen böse Menschen",
          "Gegen die geistlichen Mächte der Bosheit",
          "Gegen Regierungen",
          "Gegen Armut"
        ],
        correctAnswer: 1,
        hint: "Es geht um unsichtbare geistliche Kräfte",
        funFact: "👹 Kosmischer Kampf: Hinter menschlichen Konflikten steht echter geistlicher Krieg!"
      }
    },

    87: {
      name: "Philipper: Freude in der Prüfung",
      challenge: "Freut euch im Herrn allezeit; abermals sage ich: Freut euch!",
      easy: {
        question: "Welches Gefühl ermutigt Paulus trotz seines Gefängnisses?",
        options: ["Resignation", "Freude", "Zorn", "Traurigkeit"],
        correctAnswer: 1,
        hint: "Überraschende Emotion für einen Gefangenen",
        funFact: "😊 Freude 16 Mal in 4 Kapiteln - Rekord für Glück im Gefängnis!"
      },
      medium: {
        question: "Welche Haltung nahm Jesus laut Philipper 2 an?",
        options: [
          "Er setzte sich mit Gewalt durch",
          "Er erniedrigte und demütigte sich bis zum Tod",
          "Er floh vor seiner Verantwortung",
          "Er suchte Ruhm"
        ],
        correctAnswer: 1,
        hint: "Freiwillige Abwärtsbewegung",
        funFact: "📉 Jesus: Von der Gleichheit mit Gott zum Tod am Kreuz - extreme Liebe!"
      },
      hard: {
        question: "Wie kann Paulus im Gefängnis Freude predigen?",
        options: [
          "Er tut so als ob",
          "Christliche Freude übersteigt die Umstände",
          "Er ist masochistisch",
          "Er leugnet die Realität"
        ],
        correctAnswer: 1,
        hint: "Es geht um übernatürliche Freude",
        funFact: "✨ Freude = Frucht des Geistes unabhängig von Umständen - göttliches Geheimnis!"
      }
    },

    88: {
      name: "Die Pastoralbriefe",
      challenge: "Kämpfe den guten Kampf des Glaubens, ergreife das ewige Leben...",
      easy: {
        question: "An wen schrieb Paulus seine letzten Pastoralbriefe?",
        options: [
          "An die Korinther",
          "An Timotheus und Titus",
          "An die Römer",
          "An die Galater"
        ],
        correctAnswer: 1,
        hint: "Seine geistlichen Söhne und Mitarbeiter",
        funFact: "👨‍👦 Geistliches Testament: Paulus übergibt die Fackel an die nächste Generation!"
      },
      medium: {
        question: "Welchen Rat gibt Paulus für die Auswahl von Gemeindeleitern?",
        options: [
          "Die Reichsten wählen",
          "Nach strengen moralischen und geistlichen Kriterien wählen",
          "Die Gebildetsten wählen",
          "Die Beliebtesten wählen"
        ],
        correctAnswer: 1,
        hint: "Moralische Qualifikationen vor allem",
        funFact: "⚖️ Hohe Standards für Leiter: Charakter vor Kompetenz - göttliche Prioritäten!"
      },
      hard: {
        question: "Welches Erbe hinterlässt Paulus Timotheus?",
        options: [
          "Materielle Güter",
          "Treue zum Evangelium und pastoralen Dienst",
          "Eine politische Funktion",
          "Eine theologische Schule"
        ],
        correctAnswer: 1,
        hint: "Es geht um geistliches Erbe",
        funFact: "📜 'Bewahre das anvertraute Gut' - treue Weitergabe des Evangeliums durch die Zeitalter!"
      }
    },

    89: {
      name: "Hebräer: Jesus der Hohe Priester",
      challenge: "Wir haben einen großen Hohenpriester, der die Himmel durchschritten hat...",
      easy: {
        question: "Wer ist laut Hebräer unser großer Hoherpriester?",
        options: ["Aaron", "Mose", "Jesus", "Melchisedek"],
        correctAnswer: 2,
        hint: "Der vollkommene Mittler zwischen Gott und Menschen",
        funFact: "✝️ Jesus: Priester und Opfer - vollkommenes Opfer ein für allemal!"
      },
      medium: {
        question: "Warum ist Jesu Priestertum dem Aarons überlegen?",
        options: [
          "Es ist älter",
          "Es ist ewig nach der Ordnung Melchisedeks",
          "Es ist reicher",
          "Es ist beliebter"
        ],
        correctAnswer: 1,
        hint: "Ewigkeit vs. Zeitlichkeit",
        funFact: "♾️ Ewiges Priestertum: Jesus tritt ständig für uns ein!"
      },
      hard: {
        question: "Wie stellt Hebräer den Neuen Bund dar?",
        options: [
          "Identisch mit dem alten",
          "Überlegen und endgültig, ins Herz geschrieben",
          "Vorübergehend",
          "Optional"
        ],
        correctAnswer: 1,
        hint: "Es geht um Erfüllung und Übertreffen",
        funFact: "📋 Neuer Bund: Gesetz ins Herz geschrieben, nicht auf Stein!"
      }
    },

    90: {
      name: "Jakobus: Glaube und Werke",
      challenge: "Der Glaube ohne Werke ist tot...",
      easy: {
        question: "Was muss laut Jakobus den Glauben begleiten?",
        options: [
          "Worte",
          "Werke",
          "Emotionen",
          "Wissen"
        ],
        correctAnswer: 1,
        hint: "Praktischer Ausdruck des Glaubens",
        funFact: "🌳 Glaube = Wurzel, Werke = Früchte - vollständiger geistlicher Baum!"
      },
      medium: {
        question: "Womit vergleicht Jakobus die Zunge?",
        options: [
          "Mit einem Schwert",
          "Mit einem kleinen Feuer, das einen großen Wald entzündet",
          "Mit einem Musikinstrument",
          "Mit einem Werkzeug"
        ],
        correctAnswer: 1,
        hint: "Kleines Glied, aber große zerstörerische Kraft",
        funFact: "🔥 Zunge: Kleines Glied, aber kann ein ganzes Leben in Brand setzen - Vorsicht!"
      },
      hard: {
        question: "Wie versöhnen wir Jakobus und Paulus über Glaube/Werke?",
        options: [
          "Sie widersprechen sich",
          "Paulus spricht von Rechtfertigung, Jakobus von Heiligung",
          "Einer liegt falsch",
          "Es gibt keine Lösung"
        ],
        correctAnswer: 1,
        hint: "Es geht um zwei ergänzende Aspekte",
        funFact: "⚖️ Paulus: Gerettet durch Glauben / Jakobus: Glaube bewiesen durch Werke - perfekte Harmonie!"
      }
    },

    91: {
      name: "Offenbarung: Die Rückkehr des Königs",
      challenge: "Siehe, ich komme bald. Selig ist, wer die Worte der Weissagung dieses Buches bewahrt!",
      easy: {
        question: "An wie viele Gemeinden schreibt Johannes in der Offenbarung?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "Die Zahl der Vollkommenheit",
        funFact: "⛪ 7 Gemeinden Asiens: Spiegel aller Gemeinden aller Zeiten!"
      },
      medium: {
        question: "Wie endet die Geschichte laut Offenbarung?",
        options: [
          "Totale Zerstörung",
          "Neuer Himmel und neue Erde",
          "Rückkehr zum irdischen Paradies",
          "Ende aller Existenz"
        ],
        correctAnswer: 1,
        hint: "Vollständige Erneuerung der Schöpfung",
        funFact: "🌅 Nicht Ende der Welt, sondern totale Erneuerung - ultimative Hoffnung!"
      },
      hard: {
        question: "Welche zentrale Botschaft vermittelt die Offenbarung den Verfolgten?",
        options: [
          "Gebt auf",
          "Christus herrscht und wird endgültig siegen",
          "Flieht vor Verfolgung",
          "Rächt euch"
        ],
        correctAnswer: 1,
        hint: "Es geht um Hoffnung auf den endgültigen Sieg",
        funFact: "👑 'Der da war und der da ist und der da kommt' - Herr der Geschichte und Zeit!"
      }
    }
  }
};

export default chapter7Translations;
